import React, { useEffect } from "react";
import CustomInput from "../components/CustomInput";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  resetPassword,
  resetAuthState,
} from "../features/auth/authSlice";

let schema = yup.object().shape({
  password: yup
    .string()
    .min(6, "Password should be at least 6 characters")
    .required("Password is Required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is Required"),
});

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useParams();

  const authState = useSelector((state) => state.auth);
  const {
    isLoading,
    message,
    resetPasswordSuccess,
    resetEmail,
  } = authState;

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      dispatch(
        resetPassword({
          token,
          password: values.password,
        })
      );
    },
  });

  useEffect(() => {
    if (resetPasswordSuccess) {
      navigate("/", {
        replace: true,
        state: {
          email: resetEmail,
          successMessage: "Password reset successful. Please sign in.",
        },
      });
    }
  }, [resetPasswordSuccess, resetEmail, navigate]);

  useEffect(() => {
    return () => {
      dispatch(resetAuthState());
    };
  }, [dispatch]);

  return (
    <div className="login-front">
      <div className="login-overlay" />
      <div className="login-wrapper">
        <div className="login-card">
          <div className="login-brand">
            <h2 className="login-title mb-2">Create New Password</h2>
            <p className="login-subtitle mb-0">
              Enter your new password below to secure your Carman Autos CRM account.
            </p>
          </div>

          {message && !resetPasswordSuccess ? (
            <div className="login-error-box mt-3 text-center">
              {message?.message || message}
            </div>
          ) : null}

          <form onSubmit={formik.handleSubmit} className="mt-4">
            <div className="mb-3">
              <CustomInput
                type="password"
                label="New Password"
                id="password"
                name="password"
                onChng={formik.handleChange("password")}
                onBlr={formik.handleBlur("password")}
                val={formik.values.password}
              />
              <div className="error mt-2">
                {formik.touched.password && formik.errors.password}
              </div>
            </div>

            <div className="mb-3">
              <CustomInput
                type="password"
                label="Confirm Password"
                id="confirmPassword"
                name="confirmPassword"
                onChng={formik.handleChange("confirmPassword")}
                onBlr={formik.handleBlur("confirmPassword")}
                val={formik.values.confirmPassword}
              />
              <div className="error mt-2">
                {formik.touched.confirmPassword && formik.errors.confirmPassword}
              </div>
            </div>

            <button
              className="login-btn"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Resetting Password..." : "Reset Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;